export default "/images/02 Step1Assess-Provider-To print blank self-assessments.png?7db4b769cb0ddd2f75636e2edb2ba7d7";